import { Pagination } from "../../_CORE/APP/Templates/_UI/Kit/_index";
import "./_Styles/ViewPagination.css";

/*
    Paginador del pie del listado. Usa el Pagination del Kit y aparece
    solo cuando hay mas de una pagina, para no dejar una barra muerta.
*/

export const ViewPagination = ({ page, totalPages, total, perPage, onChange }) => {

    if (Number(perPage) === -1 || totalPages <= 1) return null;

    return (
        <div className="LStudio__app_view_pagination">

            <Pagination page={page} total={totalPages} onChange={onChange}
                totalItems={total} perPage={Number(perPage)} showInfo={false} showEdges />

        </div>
    );
};
